<script>
    import { onMount } from "svelte/internal";
    import SearchView from "./SearchView.svelte";
    import { createEventDispatcher } from "svelte";
    import ImageUploadField from "./ImageUploadField.svelte";
    const dispatch = createEventDispatcher();

    export let label = "";
    export let name = "";
    export let editable = true;
    export let value = '';
    export let type = typeof(value);
    export let id = "";
    export let required = false;
    export let placeholder = "";

    // Utilizado en el campo stepper para indicar el valor máximo y mínimo
    export let min = null;
    export let max = null;

    // Utilizado solamente para campos de tipo imageUpload
    export let maxSize = null;

    // Array de objetos para mostrar en el SearchView
    export let searchData = null;
    // Es la clave primaria del objeto searchData, que se usará para
    // saber cual de las columnas de searchData será lo que rellene
    // el text input
    export let searchKey = null;
    // Si se le pasa esta prop, entonces obtemdrá los datos de búsqueda
    // de la callback cuando haga falta
    export let searchDataCallback = null
    // Si se le pasa esta prop, entonces solo se pondrán visibles los
    // campos de searchDataCallback que se incluyan en esta lista
    export let searchDataVisibleFields = null;

    onMount(() => {
        if (Array.isArray(searchData) && 
            searchData.length &&
            typeof(searchData[0]) === "object" &&
            searchKey === null)
        {
            searchKey = Object.keys(searchData[0])[0];
        }
    });

    function onChange(evt) {
        if (type === "boolean") {
            dispatch('change', evt.target.checked);
        }
        else if (type === "imageUpload") {
            dispatch('change', evt.detail.files);
        }
        else if (type === "stepper") {
            if (evt.target.value > max) {
                evt.target.value = max;
            }
            else if (evt.target.value < min) {
                evt.target.value = min;
            }
            dispatch('change', { value: evt.target.value });
        }
        else {
            dispatch('change', { value: evt.target.value });
        }
    }

    async function onClick(evt) {
        dispatch('click', evt.target);
        if (typeof(searchDataCallback) === "function" && searchKey !== "") {
            searchData = await searchDataCallback();
            showSearchView();
        }
        else if (searchData && searchKey !== "") {
            showSearchView();
        }
    }

    let showSearchView = null;

    function searchItemSelected(evt) {
        if (evt.detail?.selection && searchKey) {
            if (type !== "boolean") {
                value = evt.detail.selection[searchKey];
                dispatch('change', { value, searchData });
            }
        }
    }

    function itemCancel() {
        dispatch('cancel');
    }

    function searchItemHover(evt) {
        dispatch('searchItemHover', evt.detail);
    }

    function searchItemOut() {
        dispatch('searchItemOut');
    }

    function stepUp() {
        if (max === value) return;
        value++;
        dispatch('change', { value, searchData });
    }

    function stepDown() {
        if (min === value) return;
        value--;
        dispatch('change', { value, searchData });
    }

</script>

{#if (searchData || typeof(searchDataCallback)==="function") && type !== "boolean"}
    <SearchView 
        bind:list={searchData}
        columns={searchDataVisibleFields}
        on:itemSelected={searchItemSelected}
        on:cancel={itemCancel}
        bind:show={showSearchView}
        on:itemHover={searchItemHover}
        on:itemOut={searchItemOut}
        />
{/if}
<div class="input-container">
{#if label}
    <label for={id}>{label}</label>
{/if}
{#if editable}
    {#if type === "string"}
        <input id={id} type="text" name={name} placeholder={placeholder} required={required} bind:value={value} on:keyup={onChange} on:click={onClick} on:focus={onClick}/>
    {:else if type === "number"}
        <input id={id} type="text" name={name} placeholder={placeholder} required={required} max={max} min={min} bind:value={value} on:keyup={onChange} on:click={onClick} on:focus={onClick}/>
    {:else if type === "stepper"}
        <button class="stepper-button" on:click={() => stepDown()}>-</button>
        <input id={id} type="number" name={name} placeholder={placeholder}  required={required} class="stepper-field" bind:value={value} on:change={onChange} max={max} min={min}/>
        <button class="stepper-button" on:click={() => stepUp()}>+</button>
    {:else if type === "boolean"}
        <input id={id} type="checkbox" name={name} placeholder={placeholder} required={required} bind:checked={value} on:change={onChange} />
    {:else if type === "html"}
        {@html value}
    {:else if type === "hidden"}
        <input id={id} type="hidden" name={name} bind:value={value} />
    {:else if type === "color"}
        <input id={id} type="color" name={name} bind:value={value} on:change={onChange} required={required}/>
    {:else if type === "imageUpload"}
        <ImageUploadField id={id} name={id} required={required} placeholder={placeholder} maxSize={maxSize} bind:value={value} on:change={onChange} />
    {:else}
        <span>{value} (unknown type)</span>
    {/if}

    {#if required}
        <span class="required">*</span>
    {/if}
{:else}
    {#if type === "boolean"}
        <span>{value ? "✅" : "❌"}</span>
    {:else if type === "html"}
        {@html value}
    {:else}
        <input id={id} type="text" value={value} disabled/>
    {/if}
{/if}
</div>

<svelte:head>
    <link rel="stylesheet" href="styles/ui/input-field.css" />
</svelte:head>
